import { LOGIN_LINKS } from 'www/constants/links'
import Hint from 'www/modules/Hint'
import { initI18n } from 'www/utils'

const chooseLoginPopup = async () => {
  const { i18next, userLanguage } = await initI18n({ bundle: 'library.blocks/common/b-choose-login-type' })
  const blockName = 'b-choose-login-type'
  const triggerBtnClass = `${blockName}__trigger-btn`
  const triggerBtnNode = document.querySelector(`.${triggerBtnClass}`)

  let authLink = LOGIN_LINKS.profile

  if (window.IS_YDOC && !window.IS_OFFICE_IP) {
    authLink = LOGIN_LINKS.profileYdoc
  }

  // не на всех страницах есть header
  if (triggerBtnNode) {
    const chooseAuthTypeHintContent = `
      <div class="${blockName}">
        <div class="pb-4 mb-4 ${blockName}__login-type">
          <div class="text-subtitle-1 text--text mb-2">
            ${i18next.t('Пациент', { ns: userLanguage })}
          </div>
          <div class="text-caption text-secondary--text mb-2">
            ${i18next.t('Делитесь отзывами о врачах, записывайтесь на приём онлайн, ведите электронную медкарту', { ns: userLanguage })}
          </div>
          <a href="${LOGIN_LINKS.medtochka}"
             class="b-button b-button_blue b-button_small"
          >
            <span class="text-button_small">${i18next.t('Войти', { ns: userLanguage })}</span>
          </a>
        </div>
        <div class="${blockName}__login-type">
          <div class="text-subtitle-1 text--text mb-2">
            ${i18next.t('Врач или клиника', { ns: userLanguage })}
          </div>
          <div class="text-caption text-secondary--text mb-2">
            ${i18next.t('Отвечайте на отзывы пациентов, включайте запись на приём, рассказывайте о ваших услугах', { ns: userLanguage })}
          </div>
          <a href="${authLink}"
             class="b-button b-button_blue b-button_small"
          >
            <span class="text-button_small">${i18next.t('Войти', { ns: userLanguage })}</span>
          </a>
        </div>
      </div>`

    new Hint({
      text: chooseAuthTypeHintContent,
      target: `.${triggerBtnClass}`,
      isMobile: false,
      modifier: blockName,
      tippyOptions: {
        interactive: true,
        placement: 'bottom-end',
      },
    })
  }
}

chooseLoginPopup()
